"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PollResult = require("./PollResult.style");

var _DarkButton = _interopRequireDefault(require("../../../Button/DarkButton"));

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var PollResult =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PollResult, _PureComponent);

  function PollResult() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PollResult);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PollResult)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onQuestionTextChange", function (event) {
      return _this.props.onQuestionTextChange(event.target.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderOneOption", function (option) {
      var poll = _this.props.poll;
      var maxVotes = Math.max.apply(Math, (0, _toConsumableArray2.default)((poll.options || []).map(function (doc) {
        return doc.votes;
      })));
      var imageUrl = option.imageUrl;
      return _react.default.createElement("div", {
        key: option.id || option.optionId,
        className: "single-option-wrapper",
        style: !imageUrl ? {
          padding: '15px 0'
        } : {}
      }, imageUrl && _react.default.createElement("img", {
        src: option.imageUrl,
        alt: option.optionText,
        className: "option-image"
      }), _react.default.createElement(_DarkText.default, {
        fontSize: 16,
        color: "silver",
        className: "option-text"
      }, option.optionText), _react.default.createElement(_DarkText.default, {
        fontSize: 14,
        color: maxVotes === option.votes ? 'emerald' : 'ruby',
        className: "option-percentage"
      }, (option.votes / poll.totalVoters * 100).toFixed(2), "%"));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderButtons", function () {
      var _this$props = _this.props,
          onClosePoll = _this$props.onClosePoll,
          onSetAnother = _this$props.onSetAnother;
      return _react.default.createElement("div", {
        className: "buttons-wrapper"
      }, _react.default.createElement(_DarkButton.default.SecondaryButton, {
        className: "end-poll-button",
        onClick: onClosePoll
      }, "Close Poll"), _react.default.createElement(_DarkButton.default, {
        className: "set-another-button",
        onClick: onSetAnother
      }, "Set Another"));
    });
    return _this;
  }

  (0, _createClass2.default)(PollResult, [{
    key: "renderOptions",
    value: function renderOptions() {
      var _this$props$poll$opti = this.props.poll.options,
          options = _this$props$poll$opti === void 0 ? [] : _this$props$poll$opti;
      return _react.default.createElement("div", {
        className: "options-wrapper"
      }, options.map(this.renderOneOption));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          poll = _this$props2.poll,
          learnersLeft = _this$props2.learnersLeft;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_PollResult.PollResultWrapper, className)
      }, _react.default.createElement(_DarkText.default, {
        fontSize: 32,
        color: "silver",
        className: "question-text"
      }, poll.questionText), _react.default.createElement(_DarkText.default, {
        fontSize: 12,
        color: "iron"
      }, learnersLeft && learnersLeft !== 0 ? "".concat(learnersLeft, " learner(s) did not answer this question") : '', !learnersLeft ? 'Everyone has given an answer' : ''), this.renderOptions(), this.renderButtons());
    }
  }]);
  return PollResult;
}(_react.PureComponent);

PollResult.defaultProps = {
  className: '',
  learnersLeft: 3
};
PollResult.propTypes = {
  className: _propTypes.default.string,
  poll: _propTypes.default.object.isRequired,
  learnersLeft: _propTypes.default.number,
  onClosePoll: _propTypes.default.func.isRequired,
  onSetAnother: _propTypes.default.func.isRequired
};
var _default = PollResult;
exports.default = _default;